import { capacityTranslationsEn } from '@/features/capacities/capacityTranslations/en';
import { collisionTranslationsEn } from '@/features/collisions/collisionTranslations/en';
import { filterTranslationsEn } from '@/features/filter/filterTranslations/en';
import { flexibleTradeSequenceTranslationsEn } from '@/features/flexibleTradeSequences/flexibleTradeSequenceTranslations/en';
import { membershipTranslationsEn } from '@/features/memberships/membershipTranslations/en';
import { orderDependencyTranslationsEn } from '@/features/orderDependencies/orderDependencyTranslations/en';
import { projectScheduleImportTranslationsEn } from '@/features/projectScheduleImport/projectScheduleImportTranslations/en';
import { projectTemplatesTranslationsEn } from '@/features/projectTemplates/projectTemplatesTranslations/en';
import { scheduleAssistantTranslationsEn } from '@/features/scheduleAssistant/scheduleAssistantTranslations/en';
import { scheduleExportTranslationsEn } from '@/features/scheduleExport/scheduleExportTranslations/en';
import { scheduleViewsTranslationsEn } from '@/features/scheduleViews/scheduleViewsTranslations/en';

import components from './components';
import countries from './countries';
import errors from './errors';
import objects from './objects';
import versioning from './versioning';

export default {
  and: 'and',
  or: 'or',
  actions: {
    add: 'Add',
    addEmail: 'Add email address',
    addNew: 'Create new',
    addNewOrSelect: 'Add new or select',
    addNow: 'Add now',
    addTo: 'Add to {item}',
    apply: 'Apply',
    archive: 'Archive',
    assignNow: 'Assign now',
    back: 'Back',
    backToOverview: 'Back',
    cancel: 'Cancel',
    cancelEdit: 'Discard now',
    close: 'Close',
    confirm: 'Confirm',
    confirmDelete: 'Yes, ',
    continueEdit: 'Continue editing',
    create: 'Create',
    createNew: 'Create New',
    createNow: 'Create now',
    createAndClose: 'Create & Close',
    delete: 'Delete',
    deleteNow: 'Delete now',
    discard: 'Discard',
    dontInsert: 'Do not insert',
    downloadAll: 'Download All',
    duplicate: 'Duplicate',
    duplicateNow: 'Duplicate now',
    edit: 'Edit',
    edited: 'Edited',
    export: 'Export',
    find: 'Find...',
    finish: 'Close',
    finishNow: 'Finish now',
    help: 'Help',
    insertNow: 'Join now',
    inviteNow: 'Invite now',
    join: 'Join',
    learnMore: 'Learn more',
    moreOptions: 'More options',
    next: 'Next',
    openDetails: 'Open details',
    previous: 'Previous',
    openInNewTab: 'Open in new tab',
    publish: 'Publish',
    redo: 'Reapply the last change after previous undo',
    reload: 'Reload',
    remove: 'Remove',
    removeNow: 'Remove now',
    removeFrom: 'Remove from {item}',
    rename: 'Rename',
    reset: 'Reset',
    revert: 'Undo',
    save: 'Save',
    saveAndClose: 'Save & Close',
    saveAndLeave: 'Save & Exit',
    saveChanges: 'Save changes',
    saveInput: 'Save Inputs',
    saveNow: 'Save now',
    search: 'Search',
    select: 'Select',
    selectNow: 'Select now',
    selectAll: 'Select All',
    selectDate: 'Select Date',
    selectAddEmail: 'Select or add email address',
    setNow: 'Define now',
    setNewOneNow: 'Redefine',
    showAll: 'Show all',
    showLess: 'Show less',
    showMore: 'Show more',
    signOut: 'Log out',
    startNow: 'Start now',
    title: 'Actions',
    undo: 'Undo the last action performed',
    underConstruction:
      'This feature is currently disabled for maintenance and will return soon. Please contact our support team if necessary',
    update: 'Update',
    updateNow: 'Update now',
    uploadPicture: 'Upload picture',
    view: 'Open',
    more: 'More',
  },
  capacities: capacityTranslationsEn,
  collisions: collisionTranslationsEn,
  commonTexts: {
    addOptionalDescription: 'Enter a description (optional)',
    unsavedChangesAreLost:
      'Do you want to discard all your changes?\nThis action cannot be undone.',
    unsavedCreateIsLost: 'Do you want to discard all your inputs?\nThis action cannot be undone.',
  },
  components,
  countries,
  errors,
  versioning,
  general: {
    absolute: 'Absolute',
    acceptanceCriteria: 'Acceptance criteria',
    achieved: 'Achieved',
    action: 'Action | Actions',
    assignment: 'Assignment',
    beta: 'beta',
    betaTooltip: 'This function can be used from now on and will be expanded very soon',
    comingSoon: 'Soon',
    content: 'Content',
    createdAt: 'Created on',
    createdBy: 'Created by',
    deadline: 'Deadline',
    description: 'Description',
    designation: 'Designation',
    display: 'Display',
    done: 'Done',
    due: 'Due',
    editedBy: 'Edited by: {name}',
    end: 'End',
    enterHere: 'Enter here',
    filter: 'Filter',
    fixed: 'Fixed',
    flexible: 'Flexible',
    general: 'General',
    last: 'Last',
    lastEdited: 'Last edited',
    loading: 'Loading...',
    more: 'More',
    name: 'Name',
    next: 'Next',
    noResults: 'No results',
    outOf: '{current} of {total}',
    nothingSelected: 'Nothing selected',
    open: 'Open',
    preview: 'Preview',
    relative: 'Relative',
    responsibility: 'Responsibility',
    select: 'Please choose',
    start: 'Start',
    status: 'Status',
    tasks: 'Tasks',
    type: 'Type',
    view: 'View',
  },
  entities: {
    companies: 'Company | Companies',
    copy: 'Copy',
    internalTeams: 'Internal Team | Internal Teams',
    members: 'Member | Members',
    milestones: 'Milestone | Milestones',
    milestonesNum: '1 milestone | {n} milestones',
    milestonesOpenNum: '1 open milestone | {n} open milestones',
    milestonesAchievedNum: '1 achieved milestone | {n} achieved milestones',
    milestonesFixedNum: '1 fixed milestone | {n} fixed milestones',
    milestonesFlexibleNum: '1 flexible milestone | {n} flexible milestones',
    objects: 'Object | Objects',
    objectsNum: '1 object | {n} objects',
    orders: 'Activity | Activities',
    ordersNum: '1 activity | {n} activities',
    ordersOpenNum: '1 open activity | {n} open activities',
    ordersDoneNum: '1 finished activity | {n} finished activities',
    ordersFixedNum: '1 fixed activity | {n} fixed activities',
    pauses: 'Project break | Project breaks',
    pausesNum: '1 project break | {n} project breaks',
    people: 'person | people',
    peopleNum: '1 person | {n} people',
    permissions: 'Permission | Permissions',
    projects: 'Project | Projects',
    projectsNum: 'a project | {n} projects',
    tasksNum: '1 task | {n} tasks',
    teams: 'Team | Teams',
    trades: 'Trade | Trades',
    tradesNum: '1 trade | {n} trades',
    workers: 'Worker | Workers',
  },
  filter: filterTranslationsEn,
  footer: {
    privacy: 'Privacy policy',
    imprint: 'Imprint',
  },
  form: {
    discard: {
      message: 'Do you want to discard all your changes?\nThis action cannot be undone.',
      title: 'Discard changes',
    },
    discardCreate: {
      message: 'All your changes will be lost. Are you sure?',
      title: 'Discard changes',
    },
    discardLatest: {
      message: 'The unsaved changes will be discarded.',
      title: 'Discard unsaved changes?',
    },
    generalSection: 'General information',
    legend: 'Legend',
    optionalField: 'optional',
    or: 'Or',
    yes: 'Yes',
    no: 'No',
    changesApplied: 'Changes have been applied',
  },
  Calendar: {
    additionals: {
      open: 'More Options',
      title: 'More',
    },
    allDaySlot: 'flexible',
    businessHours: 'Business hours',
    calendarWeek: 'CW {n}',
    calendarWeekLong: 'Calendar week',
    day: 'Day',
    employees: 'Employee',
    filter: {
      allSelected: 'All selected',
      apply: 'Apply filter',
      advancedSettings: 'Advanced settings',
      hideDependencies: 'Hide dependencies',
      hideWeekends: 'Hide weekends',
      hint: 'Change schedule view and filters',
      range: 'Select period',
      rangeStart: 'Start',
      rangeEnd: 'End',
      resetAll: 'Reset all',
      reset: 'Reset filter',
      showStatus: 'Show status view',
      teamOrCompany: 'Select team or company',
      structure: 'Select structure',
      title: 'Filter',
      trades: 'Select trades',
    },
    filterBanner: {
      trades: 'Trades',
      company: 'Companies',
      sections: 'Structure',
      range: 'Period',
    },
    sidebarDependencies: {
      deleteAll: 'Delete all dependencies',
      deleteAllConfirmation: {
        title: 'Delete dependencies?',
        body: 'Do you want to delete all dependencies?',
        confirm: 'Yes, delete dependencies',
      },
      deleteOne: 'Delete this dependency',
      highlightAllInPlan: 'Highlight all in plan',
      highlightAllInPlanHelp:
        'Double-clicking on the activity in the plan directly highlights the dependencies.',
      predecessor: 'Predecessor',
      successor: 'Successor',
      empty: 'No dependencies',
      milestoneSubtitle: 'General',
      linkButton: {
        activeTooltip: 'Open {entityType}',
        disabledTooltip: {
          title: 'Open {entityType}',
          text: 'Unable to open because the {entityType} is currently hidden.',
        },
      },
    },
    today: 'Today',
    view: {
      hint: 'Change view',
      status: 'Status',
      trades: 'Trades',
      baseActualComparison: 'Planned ↔ Actual',
      statusTooltip: 'Colored by status',
      tradesTooltip: 'Colored by trade',
      baseActualTooltip: 'Colored by planned-actual comparison',
    },
  },
  Dashboard: {
    title: 'Dashboard',
    missingPhoneNumber:
      'Your phone number is still missing. Enter it so that your profile is complete and you can be contacted via the app.',
  },
  Drawer: {
    open: 'Open menu',
    close: 'Close menu',
  },
  flexibleTradeSequences: flexibleTradeSequenceTranslationsEn,
  inputTexts: {
    responsibleDropdown: 'Select responsible',
    responsibleDropdownSearch: 'Search for responsible',
  },
  PhotoDocumentation: {
    title: 'Photo documentation',
    subtitle: 'Here you can find all the photos of your activities',
    photo: 'Photo | Photos',
    filterHint: 'Change photo appearance and filters',
    exportAll: 'Download all photos',
    exportResults: 'Download photos',
    noPhotosAddedTitle: 'No photos added yet',
    noPhotosAddedBody: 'You can add photos to your activities in the schedule.',
    noResultsTitle: 'No photos found',
    noResultsBody: 'Try changing the filter settings.',
    exportSnackbarSuccessTitle: 'Creating export file',
    exportSnackbarSuccessSubtitle:
      'You will receive an email with a download link after the export is done.',
    exportSnackbarErrorTitle: 'Export failed',
    exportSnackbarErrorSubtitle: "Something wen't wrong, please try again later.",
    viewByWeek: 'By week',
    viewByMonth: 'By month',
    week: 'CW {n}',
    photoTrade: 'Trades',
    photoOrder: 'Activity',
  },
  TenantTemplates: {
    title: 'Templates',
    subtitle: 'Here you can find the templates that can be used in any project',
    tradesTitle: 'Trades',
    tradeSequencesTitle: 'Sequences',
    projectStructuresTitle: 'Project structure',
    projectTemplatesTitle: 'Project templates',
    tradeSequenceComingSoonBody: 'This feature is currently under development.',
    createTrade: 'Create trade',
    searchTrade: 'Search trade',
    noTradeResults: 'No trades found',
    noTrades: 'No trades have been created yet',
    createTradeSequence: 'Create sequence template',
    searchTradeSequence: 'Search sequence',
    noTradeSequenceResults: 'No sequence found',
    noSequenceTemplate: 'No sequence templates have been created yet',
    noSequenceTemplateHint:
      'You can create a sequence template and then see and use it company-wide in every project.',
    name: 'Name',
    headerEditTemplateTitle: 'Edit sequence template',
    tradeSequenceTeaserTitle: 'You are interested in sequence templates?',
    tradeSequenceTeaserContent:
      'Templates allow you to define sequences once and reuse them in all your projects.',
    tradeTeaserTitle: 'You are interested in trade templates?',
    tradeTeaserContent:
      'Templates allow you to define trades once and reuse them in all your projects.',
    teaserCTA: 'Contact us',
    teaserHelp: 'How does it work?',
    projectStructureTeaserTitle: 'You are interested in structure templates?',
    projectStructureTeaserContent:
      'You can create templates for the structure of projects and then use them company-wide for each of your projects.',
    createStructureTemplate: 'Create structure template',
    searchStructureTemplate: 'Search structure template',
    noStructureTemplatesResults: 'No matching structure templates available',
    noStructureTemplates: 'No structure templates available',
    projectStructureTeaserShortContent: 'You are interested in structure templates?',
  },
  keyboard: {
    ctrl: 'Ctrl',
    alt: 'Alt',
    space: 'Space',
    click: 'Click',
    enter: 'Enter',
    escape: 'Esc',
  },
  LeanDashboard: {
    title: 'Dashboard',
    dashboard: 'Dashboard',
    edit: {
      address: 'Edit project address',
      button: 'Edit',
      title: 'Edit project',
      submit: 'Update now',
      delete: 'Delete project',
      finish: 'Finish project',
    },
    exit: 'Exit project',
    subcontractors: 'Company | Companies',
    team: 'Team',
    status: 'Current status',
    overview: 'Schedule',
    next: 'Go to next category',
    backToDashboard: 'Back to the Dashboard',
    welcomeMessage: {
      button: 'Set now',
      message:
        'In the background you can already see your project overview. Before you can really get started, we still have to make some settings to be able to execute your planning properly.',
      title: 'Your project has been created',
    },
    missingPhoneNumber: {
      title: "Other participants can't reach you",
      subtitle:
        'Add your phone number to your profile now so that other project participants can reach you.*',
      footnote1: {
        text: '*You can always add your phone number in the section {location}.',
        button: 'My profile',
      },
      footnote2: '**Phone numbers are visible in the project for all other participants.',
      benefits: {
        1: 'Automatic phone book**',
        2: 'Direct contact options',
        3: 'Improved communication',
      },
      addNumber: 'Add phone number',
      later: 'Later',
    },
    progress: {
      completed: {
        message: 'Project finished',
      },
      title: 'Project progress',
      status: 'Project active',
      statusActive: 'Project active',
      statusComplete: 'Project completed',
      setup: {
        title: 'Data entry',
        textComplete:
          'You have entered {progress}% of the required data. You can activate the project now.',
        button: 'Activate project now',
        text: 'You have entered {progress}% of the required data so far. Enter all data to activate the project.',
        popup: {
          title: 'Activate project',
          text: 'When you confirm, the project will be activated.',
          incomplete: {
            title: 'For your information',
            text1:
              'In your train creation there is still one trade to which no contractor has been assigned yet. | In your train creation there are still {n} trades to which no contractor has been assigned yet.',
            text2: 'However, you can add contractors later.',
            assign: 'Assign contractors',
          },
        },
      },
    },
    refreshedAt: 'Dashboard refreshed at {date}',
    tickets: 'Tickets',
  },
  LeanOrderDetails: {
    title: 'Task details',
  },
  LeanOrderEdit: {
    action: 'Update operation',
    success: 'Task successfully updated',
    title: 'Edit activity',
  },
  LeanProjects: {
    delete: {
      buttonText: 'Delete project',
      message:
        'If you confirm, all records for this project and its tasks will be deleted! Are you sure?',
      success: 'Project deleted',
    },
    finish: {
      title: 'Finish project',
      subtitle:
        'Do you really want to finish the project? Subsequent editing or reactivation is not possible.',
      buttonText: 'Finish now',
    },
    LeanProjectsAll: {
      archivedByAt: 'Archived by {name} on {date}',
      title: 'Projects',
      onlyMyProjects: 'Show only my projects',
      real: {
        title: 'Real Projects',
        empty: 'No real projects found',
        emptyDescription: 'Projects will show here once added',
        noSearchResults:
          'Your search "{search}" did not match any real projects. Please check a different tab or try a different query.',
        results: 'View {count} result in Real projects | View {count} results in Real projects',
      },
      test: {
        title: 'Test Projects',
        empty: 'No test projects found',
        emptyDescription: 'Projects will show here once added',
        noSearchResults:
          'Your search "{search}" did not match any test projects. Please check a different tab or try a different query.',
        results: 'View {count} result in Test projects | View {count} results in Test projects',
      },
      archive: {
        title: 'Archive',
        empty: 'No archived projects found',
        emptyDescription: 'Projects will show here once archived',
        noSearchResults:
          'Your search "{search}" did not match any archived projects. Please check a different tab or try a different query.',
        results: 'View {count} result in the Archive | View {count} results in the Archive',
      },
      status: {
        test: 'Test project',
        inPreparation: 'In preparation',
        active: 'Active',
        completed: 'Completed',
        archived: 'Archived project',
      },
      notFound: 'No projects found',
      searchBarPlaceholder: 'Search project',
      sortBy: {
        name: 'Name',
        projectNumber: 'Project number',
        status: 'Status',
        createdAt: 'Created at',
        lastUpdatedAt: 'Last updated at',
      },
    },
    LeanProjectCreate: {
      header: 'Add a new project',
      realProjectHeader: 'Add a real project',
      testProjectHeader: 'Add a test project',
      submit: 'Add now',
      success: 'Project successfully created',
      title: 'Add a new project',
    },
    LeanProjectDetails: {
      planning: 'Schedule',
      status: 'Current status',
    },
    LeanProjectEdit: {
      editPicture: 'Edit project picture',
    },
  },
  LeanProjectSchedule: {
    title: 'Schedule',
  },
  LeanProjectStatus: {
    title: 'Current status',
  },
  Login: {
    login: 'Login',
    error: {
      networkError: 'Unable to connect to the server. Check your Internet connection.',
      wrongCredentials:
        'The combination of e-mail and password is wrong or your account is only linked to Microsoft.',
      tooManyRequests: 'Too many log in attempts, please wait a moment and try again.',
    },
    forgotPassword: 'Forgot your password?',
    signIn: 'Log in',
    signInLong: 'Log in to account',
    signUp: 'Register',
    title: 'Login',
    visibleTitle: 'Welcome back',
    visibleSubtitle: 'Manage your construction projects with koppla.',
    signInWithMicrosoft: 'Log in with Microsoft',
    microsoftErrorTitle: 'Log in with Microsoft not possible',
  },
  Contributors: {
    constraintsUserIsAlreadyProjectManagementMember:
      'The person is already member of the project management',
    constraintsUserIsAlreadyInternalTeamMember:
      'The person is already member of at least one internal team',
    constraintsUserIsAlreadyExternalTeamMember: 'The person is already member of an external team',
    constraintsUserIsCurrentTenantMember:
      'Members of the company can not be added to external teams',
    pageHelp: 'How to manage teams and companies',
    pageTitle: 'Project participants',
    projectManagement: 'Project management',
    teamsAndCompanies: 'Teams and companies',
    defaults: {
      added: 'Set {contributorGroup} as default for {trade} ',
      alreadySelected: 'Another team or company has already been set as the default for the trade.',
      selected: 'Default for {trade}, click to remove',
      notSelected: 'Click to set as default for {trade} ',
      removed: '{contributorGroup} removed as default for {trade} ',
    },
    ChangesSavedDialog: {
      title: 'Changes got saved',
      invited: 'Invitation sent',
      reinviteCTA: 'Invite again',
      reinvited: 'Invited',
      added: 'Added',
      removed: 'Removed',
    },
    ContributorAdd: {
      selectTypeDialog: {
        title: 'Add a new team or company',
        internalTeamTitle: 'Internal team',
        internalTeamSubtitle:
          '• Internal Team of your company\n' +
          '• Consists of your colleagues\n' +
          '• Not part of project management',
        companyTitle: 'Companies',
        companySubtitle:
          '• Contractually commissioned for individual tasks (trades)\n' +
          '• External contributors\n' +
          '• Not part of your company',
      },
      addCompanyDialog: {
        title: 'Add a new company',
        companyNameLabel: 'Company name*',
        tradesTitle: 'Trades',
        membersTitle: 'Members',
        membersLabel: 'Add members by email address',
        addEmailAddressHint: 'Add email address',
      },
      addTeamDialog: {
        title: 'Add a new team',
        teamNameLabel: 'Team name*',
        membersLabel: 'Add members from your organisation or by email address',
      },
    },
    ContributorEdit: {
      title: 'Edit {contributorGroup}',
      yourChanges: 'Your changes',
      addGroup: 'Add {contributorGroup}',
      inviteGroup: 'Invite {contributorGroup}',
      removeGroup: 'Remove {contributorGroup}',
      editTradesTitle: 'Edit trades',
      editMembersTitle: 'Edit members of {contributorGroup}',
    },
    ContributorDelete: {
      buttonText: 'Remove team or company',
      message:
        'Do you want to remove the selected team or company from the project? Existing assignments to tickets and tasks will be removed.\n\nThis action cannot be undone.',
      dialogTitle: 'Delete {contributorGroup}',
      dialogDescription: 'This action is irreversible and cannot be undone.',
      successNotification: '{contributorGroup} got deleted',
    },
    ContributorTable: {
      empty: {
        generalTitle: 'Add your first team or company',
        generalDescription:
          'Add internal teams with members from your organisation or external companies such as service providers or subcontractors.',
        internalTeamTitle: 'Add your first internal team',
        internalTeamDescription: 'Add internal teams with members from your organisation.',
        companyTitle: 'Add your first external company',
        companyDescription: 'Add external companies such as service providers or subcontractors.',
      },
      addTeamOrCompany: 'Add new team or company',
      addTeam: 'Add new team',
      addCompany: 'Add new company',
      searchTeamOrCompany: 'Search team or company',
      noResultsFound: 'No results found',
      noResultsFoundGeneralBody:
        'Your search "{searchInput}" did not match any team or company. Please try a different spelling.',
      noResultsFoundCompanyBody:
        'Your search "{searchInput}" did not match any company. Please check a different tab or try a different spelling.',
      noResultsFoundTeamBody:
        'Your search "{searchInput}" did not match any team. Please check a different tab or try a different spelling.',
      unassignedTrades: '{n} trade left to be assigned | {n} trades left to be assigned',
      viewResultsWithinCompanyButton:
        'View {n} result within companies | View {n} results within companies',
      viewResultsWithinTeamButton: 'View {n} result within teams | View {n} results within teams',
    },
    OrderEdit: {
      selectPlaceholder: 'Select team or company',
    },
    Permissions: {
      permission: 'Permission',
      basic: 'Basic',
      basicDescription: 'reporting statuses and uploading images for assigned orders',
      extended: 'Extended',
      extendedDescription: 'editing assigned orders and creating own ones',
      extendedAlert: 'at least one trade needs to be assigned',
      permissionChangedNotificationTitle:
        'Permissions for {contributorGroup} got automatically adjusted!',
      permissionChangedNotificationBody:
        'Extended permissions can only be granted to companies and teams with assigned trades.',
    },
  },
  memberships: membershipTranslationsEn,
  misc: {
    browserUnsupported: {
      message:
        'Open this page in a new version of Google Chrome, Mozilla Firefox, Microsoft Edge or Safari to use koppla.',
      title: 'Your browser is not supported',
    },
  },
  Changelog: {
    title: 'News',
  },
  Company: {
    CompanyDetails: {
      address: 'Address',
      title: 'My company settings',
    },
  },
  legal: {
    acceptance: 'By clicking {actionText} you agree to the {terms} and {privacy}.',
    privacyPolicy: 'Privacy policy',
    terms: 'Terms and Conditions',
    termsShort: 'Terms and Conditions',
  },
  NoMemberships: {
    text: 'Contact the administrator of your company to add you to your company.',
    title: 'You do not have any workplaces yet',
  },
  objects,
  Orders: {
    forms: {
      emptySelect: 'Add new customers with "+".',
      error: {
        errorCreateHint: 'Required inputs to create the activity are missing!',
        errorEditHint: 'Required inputs to update the activity are missing!',
      },
      fixOrder: 'Fix activity',
      missingPhoneNumber:
        'Your phone number is still missing. After you have entered it, we will take you directly back to the activity.',
      sections: {
        tasks: 'Tasks',
        tickets: 'Tickets',
      },
      useCustomerAddress: 'Take over customer address',
      useFullDayEvent: 'Book as a flex activity',
      useOwnTenantAddress: 'Take over own address',
    },
    OrderCreate: {
      followUpSuccess: 'Follow-up activity successfully created',
      redirectToOrderForm: 'To advanced creation',
      success: 'Activity created successfully',
      title: 'Create activity',
    },
    OrderDetails: {
      action: 'Open activity',
      delete: {
        buttonText: 'Delete activity',
        message: 'If you confirm, all records for this activity will be deleted! Are you sure?',
        success: 'Activity successfully deleted',
      },
      editLeanStatus: {
        title: 'Report current status | Report current status ({n} orders)',
        submit: 'Report now',
      },
      editStatus: {
        title: 'Edit status',
        reactivate: {
          title: 'Reactivate activity',
          message: 'The existing activity is reactivated. The working time is continued.',
          button: 'Reactivate now',
          success: 'The existing activity has been reactivated successfully',
        },
        replan: {
          title: 'Reschedule activity',
          message: 'The existing activity is rescheduled. The working time is continued.',
          button: 'Schedule now',
        },
        followUp: {
          title: 'Create follow-up activity',
          message:
            'A follow-up activity is created with all the original specifications. The working time starts again from the beginning.',
          button: 'Create now',
        },
        finish: {
          title: 'Defect has been corrected',
          message: 'The defect has already been corrected and the activity can be finished',
          button: 'Finish now',
          success: 'The original defective activity has been successfully finished',
        },
      },
      title: 'Activity details',
    },
    OrderCopy: {
      action: 'Copy activity',
      success: 'activity successfully copied',
      title: 'Copy activity',
    },
    OrderEdit: {
      action: 'Update activity',
      lean: {
        action: 'Update operation',
        success: 'Task successfully updated',
        title: 'Edit activity',
      },
      success: 'Activity successfully updated',
      title: 'Edit activity',
    },
    OrdersAll: {
      title: 'Activities',
      empty: 'No activities available',
      sorting: {
        action: 'Sort by',
        startAt: {
          ascending: 'Start date ascending',
          descending: 'Start date descending',
        },
        startedAt: {
          ascending: 'Start date ascending',
          descending: 'Start date descending',
        },
        createdAt: {
          ascending: 'Creation date ascending',
          descending: 'Creation date descending',
        },
        finishedAt: {
          ascending: 'End date ascending',
          descending: 'End date descending',
        },
      },
    },
    title: 'Tasks',
  },
  orderDependencies: orderDependencyTranslationsEn,
  OrderTasks: {
    create: 'Add task',
    createFromListTitle: 'Select template',
    createFromList: 'From template',
    delete: {
      buttonText: 'Delete task',
      message: 'Do you want to delete the selected task?\nThis action cannot be undone.',
    },
    subtitle: 'Tasks must be completed before finishing the activity.',
    title: 'Task | Tasks',
    update: 'Update task',
  },
  Participants: {
    Memberships: {
      title: 'Project participants',
    },
    Subcontractors: {
      title: 'Project participants',
    },
  },
  Partnerships: {
    PartnershipsAll: {
      title: 'Partner Companies',
      delete: {
        buttonText: 'Unlink',
        message: 'If you confirm, you will no longer be able to work with this company.',
        success: 'Partner companies successfully removed from your network',
      },
      empty: 'You do not have any affiliates yet.',
      tableInfo: 'You can add new partner companies inside your projects.',
    },
    PartnershipCreate: {
      error: {
        tenantIsAlreadyPartner: 'This company is already registered as your affiliate',
      },
      success: 'Partner company added to your network',
      title: 'Add a partner company',
    },
  },
  PickTenant: {
    title: 'Hi {name}!',
    subtitle: 'Select your company',
    showExternalProjects: 'Show my externally assigned projects',
  },
  Projects: {
    projectNotFoundTitle: 'Project not found',
    projectNotFoundMessage: "The project you were trying to open doesn't exist.",
    projectNotFoundCTA: 'To project overview',
    ProjectCreate: {
      success: 'Project successfully created',
      title: 'Create project',
    },
    ProjectDetails: {
      delete: {
        buttonText: 'Delete project',
        message:
          'If you confirm, all records for this project and the corresponding activities will be deleted! Are you sure?',
        success: 'Project successfully deleted',
      },
      title: 'Project details',
    },
    ProjectEdit: {
      action: 'Update project',
      success: 'Project successfully updated',
      title: 'Edit project',
    },
    ProjectsAll: {
      title: 'Projects',
      empty: 'No projects available',
    },
    select: {
      title: 'Select project',
    },
    title: 'Projects',
    ProjectErrors: {
      shorthandDuplicate:
        'The project abbreviation already belongs to another project. Please choose a new abbreviation!',
    },
  },
  projectScheduleImport: projectScheduleImportTranslationsEn,
  projectTemplates: projectTemplatesTranslationsEn,
  RegisterTenant: {
    error: {
      emailExists: 'An account already exists for this email. Click on "Go to login" to log in.',
      emailNotExists:
        'The user with this email does not exist. You must enter the mail of an existing user!',
      nameAlreadyExists: 'A company with this name already exists.',
    },
    initiateRegistration: 'Register company',
    onJoinTenant: {
      subtitle:
        'Please check your inbox and verify your email address. After that your koppla administrator only has to add you to your workplace. When he has done that you can start right away.',
      title: 'Join registered company',
    },
    selectOrCreate: {
      title: 'Create or join a company',
      subtitle: 'Create a new company or join a registered company.',
    },
    success:
      'Please check your inbox and verify your email address. Then you can start adding employees to your company right away.',
    title: 'Create a new company',
  },
  ResetPassword: {
    button: 'Send link',
    errorTitle: 'Password reset failed',
    noAccountError: 'There is no account for the given email.',
    microsoftAccountError: 'Your account is linked to Microsoft, we cannot reset your password.',
    success: 'We have sent you a link to reset your password to {email}.',
    successTitle: 'Email to reset password sent.',
    title: 'Reset password',
    text: 'Enter the email address associated with your account and we will send you a link to reset your password.',
  },
  Routing: {
    appstore: {
      google_store: 'Download for Android',
      ios_store: 'Download for iOS',
    },
  },
  SetPassword: {
    button: 'Send',
    errorTitle: 'Password reset failed',
    invalidCode: 'The link has either expired or has already been used.',
    successTitle: 'Password successfully reset',
    success: 'Your password was reset. You can now log in with your new password.',
    title: 'Reset password',
    text: 'Choose a new password for the account using the email {email}.',
  },
  scheduleAssistant: scheduleAssistantTranslationsEn,
  scheduleExport: scheduleExportTranslationsEn,
  scheduleViews: scheduleViewsTranslationsEn,
  Settings: {
    title: 'Settings',
  },
  SignUp: {
    backToLogin: 'Go to login',
    backToSignUpMethod: 'Back to sign up method',
    alreadyHaveAnAccountQuestion: 'Already signed up for koppla?',
    continueWithMicrosoft: 'Continue with Microsoft',
    continueWithEmail: 'Continue with mail',
    error: {
      emailAlreadyExists: 'This e-mail is already in use.',
      phoneAlreadyExists: 'This phone number is already in use.',
    },
    noInvitation: {
      title: 'No invitation link available',
      subtitle: 'The creation of a koppla account is only possible by invitation',
    },
    initiateSignUp: 'Accept & register',
    loginAfterSignUp: 'Open koppla',
    withTenant: {
      subtitle: 'Join {tenant} on koppla.',
      title: 'Register for koppla',
    },
    withoutTenant: {
      subtitle: 'Create your koppla account now',
      title: 'Start with koppla',
    },
    success:
      'You are now a member of the koppla-workplace of {tenant}. Log in now here or in our app.',
    microsoftErrorTitle: 'Sign up with Microsoft not possible',
    invitationErrorTitle: 'Oops, something went wrong',
    invitationErrorMessage:
      'Your invitation is expired or was already accepted. If you already signed up, press {loginCta} to log in.',
    invitationLoginCta: 'Login now',
  },
  singleWords: {
    of: 'of',
  },
  SiteSettings: {
    analytics: 'Analytics',
  },
  Tickets: {
    title: 'Tickets',
    filter: {
      allSelected: 'All selected',
      apply: 'Apply filter',
      hint: 'Filter tickets',
      location: 'Location',
      locationSelect: 'Select components',
      range: 'Select deadline period',
      rangeStart: 'Start',
      rangeEnd: 'End',
      reset: 'Reset filter',
      select: 'Please select',
      statuses: 'Select current status',
      subcontractors: 'Companies',
      title: 'Choose filter',
      trades: 'Trades',
      types: 'Select ticket type',
    },
  },
  time: {
    date: 'Date',
    days: '{n} day | {n} days',
    daysJustText: 'day | days',
    hours: '{n} hour | {n} hours',
    minutes: '{n} minute | {n} minutes',
    months: '{n} month | {n} months',
    monthsJustText: 'Month | Months',
    monthsLast: 'Last month | Last {n} months',
    monthsNext: 'Next month | Next {n} months',
    oClock: 'Clock',
    setTimeSpan: 'Set time span',
    time: 'Time',
    weekdays: 'Mon,Tue,Wed,Thu,Fri,Sat,Sun',
    weeks: '{n} week | {n} weeks',
    weeksJustText: 'Week | Weeks',
    weeksLast: 'Last week | Last {n} weeks',
    weeksNext: 'Next week | Next {n} weeks',
    workingDays: '1 working day | {n} working days',
    workingDaysJustText: 'working day | working days',
    years: '{n} year | {n} years',
    yearsJustText: 'Year | Years',
    yearsLast: 'Last year | Last {n} years',
    yearsNext: 'Next year | Next {n} years',
  },
  Update: {
    text: 'A new software version of koppla is available',
    button: 'Update',
  },
  Users: {
    legalInformation: 'Legal Information',
    myCompanies: 'Switch company',
    myProfile: 'Edit profile',
    UserDetails: {
      title: 'Profile overview',
    },
    UserEdit: {
      action: 'Update profile',
      success: 'Profile successfully updated',
      title: 'Profile & Settings',
      description: 'Your profile is visible to members of your company and project participants.',
      settings: 'Settings',
      profilePicture: {
        title: 'Edit profile picture',
        new: 'New profile picture',
      },
      missingPhoneNumber:
        'Enter your phone number here. After updating you will automatically come back to the activity.',
    },
  },
  WaitingTimeContent: {
    next: 'Next content',
    contents: {
      0: 'There are around 79.000 construction companies in Germany.',
      1: 'Concrete has been used for over 2000 years.',
      2: 'The word ‘project’ stems from the latin ‘proiectum’ and means “thrown in the front”.',
      3: 'Our company name originates from the Swedish word “koppla”, which means “connect”.',
      4: 'Building sites are less effective than 40 years ago - biggest leverage here is good project management.',
      5: 'The longest tunnel in the world is the 57km long Gotthard Base Tunnel.',
      6: 'The worlds longest bridge is the 164.8km long Danyang–Kunshan Grand Bridge in China.',
      7: 'The Great Pyramid of Giza was the tallest structure in the world for over 3,800 years.',
      8: 'There are 10 million bricks in the Empire State Building.',
      9: 'More than 180 million people work in construction around the world.',
      10: 'Willi Maier holds the record for hammering 24 nails, in 1 minute.',
      11: 'China is the country with more skyscrapers, followed by the United States and Japan.',
      12: 'The majority of the industry is made up of small construction firms.',
      13: 'The Boeing Factory in Everett, Washington, is the world’s largest building by volume.',
      14: 'The building industry is responsible for roughly 20% of global emissions.',
      15: 'Construction teams spend 13% of their time searching for project data and facts.',
      16: 'koppla was founded on April 21, 2020.',
      17: 'With over 75 km, the Dubai Metro is the longest fully automated subway in the world.',
      18: 'The Sagrada Familia in Barcelona has been under construction for 137 years and is still not finished. Should someone tell them about koppla?',
      19: 'The Pantheon in Rome has the largest cantilevered dome in the world (43m diameter) and is also quite massive: each individual column weighs 60 tons - as much as 70 elephants!',
      20: 'Translucent concrete is concrete that lets light through!',
      21: '3D-printed concrete not only reduces the amount of work, but also the amount of concrete required - and thus the CO2 emissions, which are very high with this building material.',
      22: 'In 2020, around 893,000 people in Germany were employed in the main construction trades.',
      23: 'You can remove scratches in the floor or wooden furniture with walnuts. Rub the nut over the scratch several times and watch the magic happen.',
      24: 'The average site manager spends 3-5 hours per day communicating. 2-4 hours of this time are repetition.',
      25: 'We have most of our building projects in the Hamburg area.',
      26: 'The longest sand castle was built in 2011 on a beach in North Germany - 26,38 kilometres.',
      27: 'If you are in Berlin, feel free to say hi for a cup of coffee!',
      28: 'Rubiks cubes are the classic pastime. The record for the fastest solve is 4.22 seconds!',
      29: 'The longest Lego train track is 4,000.25 m long and consisted of almost 100,000 parts!',
      30: 'The world’s longest table was built in Finland. It was 1.3 km long - more than 12 soccer fields! Challenge accepted?',
      31: 'Nobody knows who really built the Taj Mahal. To this day, it is not clear who the main architect was.',
      32: 'Schedules in MS Project are so confusing that project managers often edit them graphically before presenting them to the other trades. (Fortunately there is koppla now!)',
      33: 'Architecture was olympic until 1948.',
      34: 'One speaks of "Manhattanization" when a city is remodeled and many skyscrapers and large buildings are planned.',
      35: "Just a second! We'll just get that tool out of the way…",
      36: 'Just a moment, we move the crane to the side before we continue.',
      37: 'Just a moment, the excavator has to roll through here for a moment.',
      38: 'Nobody is perfect — even at koppla there are loading times.',
      39: 'Little challenge while waiting: How long can you balance a spirit level on one finger?',
      40: "We love construction sites as much as you do! That's why we've opened one here for a moment. Go straight on!",
      41: '“Making a plan without the right tools is like making spaghetti without a pot.”',
      42: 'By failing to prepare, you are preparing to fail. - Benjamin Franklin',
      43: 'Every minute you spend in planning saves 10 minutes in execution - Brian Tracy',
      44: '“Spectacular achievement is always preceded by unspectacular preparation.” ― Robert H. Schuller',
      45: 'Good preparation is everything: “Always plan ahead. It wasn’t raining when Noah built the ark.” – Richard Cushing',
      46: 'Always rely on: "Good fortune is what happens when opportunity meets with planning." - Thomas Edison',
      47: '“You can design and create, and build the most wonderful place in the world. But it takes people to make the dream a reality.” – Walt Disney',
      48: '“Good buildings come from good people, and all problems are solved by good design.” (Stephen Gardiner) — or by good planning.',
      49: 'Stay hydrated - how about a sip of water while you wait?',
      50: 'While you wait: what has been your highlight so far today?',
      51: 'koppla is still running - time for a coffee!',
      52: 'Use the waiting time for a quick chat with someone you rarely talk to.',
      53: 'koppla is running at full speed - how about a run around the construction container in the meantime?',
      54: 'Here you have a minute to crank up your favorite song.',
      55: 'While koppla is working - stretch yourself out again.',
      56: 'Short break - you can put your feet up for a few seconds!',
      57: 'Did you know that you can add project breaks? Check out the first row of your schedule!',
      58: 'You can forward your wishes to us via the feedback button on the right.',
      59: 'We pass on every single piece of feedback you give us to our product development.',
      60: 'You can also use koppla on touch screens like the Samsung Flip 2.',
      61: 'We will display your company logo on the PDF export of the schedule.',
      62: 'Sequence templates can easily be duplicated! You can find the function in the menu at the top right.',
    },
  },
  MicrosoftSSO: {
    connectionErrorTitle: 'Connection with Microsoft not possible',
    emailsNotMatchingErrorMessage:
      "Microsoft account with mail {email} cannot be linked because mail doesn't match that of koppla account.",
    flowCanceledErrorMessage: 'The process was canceled. Please try again later.',
    unknownUserError: 'There is no account for {email}. You must be invited to use koppla.',
    signInAccountNotLinkedError:
      'The koppla account is not linked to Microsoft. Sign in with your email and enable Microsoft SSO via the profile page.',

    illegalEmailDomainError: "Only emails of the domain '{domain}' can be used for the tenant.",
  },
  fixed: 'Fixed',
  typeToSearch: 'Type to search',
  createdBy: 'Created by: {creator}',
  targetActualSuffix: '(Actual & Target)',
};
